import React from 'react';
import { Phone, Mail } from 'lucide-react';

export default function FieldReportHeader({ reportType, reportNumber }) {
  return (
    <div className="px-6 pt-2 pb-3 border-b border-slate-200">
      <div className="flex items-center justify-between">
        {/* Logo - Left */}
        <div className="flex-shrink-0 -mt-2">
          <img
            src="https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/69b5afabd540121a86879b5b/e29b4c6b2_CLLLogoTransparent.png"
            alt="Center Line Locating"
            className="h-24 w-auto object-contain"
          />
        </div>
        
        {/* Address Info - Center.
            `min-w-0` lets the center column shrink below its
            intrinsic content width on narrow viewports (phones /
            portrait tablets). Previously the phone + email spans had
            `whitespace-nowrap`, which forced the center column to be
            at least ~305px wide even at 400px viewports — that pushed
            the right-side report number past the doc's overflow-hidden
            edge, clipping "GREASE FORM" and the trailing digits of
            the form number. Dropping the nowrap here lets phone/email
            wrap to a second line only when there isn't room to fit —
            desktop rendering is unchanged. */}
        <div className="flex-1 min-w-0 text-center px-4">
          <p className="text-[12px] text-slate-700 font-medium">12030 Goodrich Dr, Charlotte, NC 28273</p>
          <p className="text-[11px] text-slate-500">PO Box 38251, Charlotte, NC 28278</p>
          <div className="flex items-center justify-center flex-wrap gap-x-4 gap-y-0.5 mt-1 text-[11px] text-slate-500">
            <span className="flex items-center gap-1"><Phone className="w-3 h-3" />(704) 315-5820</span>
            <span className="flex items-center gap-1"><Mail className="w-3 h-3" />requests@cllocating.com</span>
          </div>
        </div>
        
        {/* Report Number - Right.
            max-w-[180px] caps the column so long job numbers (e.g.
            internal test IDs like TEST_ITER83_PC_1780439985, 25 chars)
            can't push past the document's right edge and get clipped by
            its overflow-hidden mask. text-sm + break-all let the long
            string wrap onto two lines; short IDs still render on one
            line and look unchanged. */}
        <div className="text-right flex-shrink-0 max-w-[180px]">
          <p className="text-[10px] text-slate-400 uppercase tracking-wider">{reportType}</p>
          <p className="text-sm font-bold text-slate-800 break-all leading-tight">#{reportNumber || 'Draft'}</p>
        </div>
      </div>
    </div>
  );
}
